import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

import { URLS } from "../../constants/constants";
import { AuthService } from "../../../common/services/auth.service";
import { GetGradesResponseDto } from "../dtos/get-grades.response.dto";



@Injectable()
export class GradeBookService {
private http = inject(HttpClient);
private authService = inject(AuthService)
    
    getGrades(lineItemId:string,{skip,limit,sortField,sortOrder,searchQuery}:{skip:number,limit:number,sortField:string,sortOrder:string,searchQuery?:string}) : Promise<GetGradesResponseDto>{
        let url = `${URLS.LINE_ITEMS_API}/${lineItemId}/results?skip=${skip}&limit=${limit}&sortField=${sortField}&sortOrder=${sortOrder}`;
        if (searchQuery) {
            url += `&searchQuery=${encodeURIComponent(searchQuery)}`;
        }
        return firstValueFrom(this.http.get<GetGradesResponseDto>(url, {
            headers: this.authService.getAuthHeaders()
        })); 
    }
   
   
}